import { useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';

import './App.css';
import AppRoutes from './app/routes';
import PageLayout from './components/PageLayout';
import { createBlockScanQueryClient } from './api/queryClient';
import AppErrorBoundary from './app/AppErrorBoundary';

function App() {
  const [queryClient] = useState(createBlockScanQueryClient);
  const location = useLocation();
  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <AppErrorBoundary key={location.pathname}>
          <PageLayout>
            <AppRoutes />
          </PageLayout>
        </AppErrorBoundary>
      </div>
    </QueryClientProvider>
  );
}

export default App;
